import App from '@/models/App'

export default class TrafficShipRecord extends App {
    static get entity() {
        return 'TrafficShipRecords'
    }

    static all() {
        return this.query().orderBy('createdAt', 'desc').get()
    }

    static getPastRecords() {
        return this.query()
            .where('isCurrent', false)
            .orderBy('createdAt', 'desc')
            .get()
    }

    static getCurrentRecord() {
        return this.query().where('isCurrent', true).first()
    }

    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }

    static fields() {
        return {
            id: this.attr(''),
            trafficShipId: this.attr(''),
            voyageNumber: this.attr(''),
            depCountry: this.attr(''),
            depPort: this.attr(''),
            destCountry: this.attr(''),
            destPort: this.attr(''),
            cargoContent: this.attr(''),
            currentStatus: this.attr(''),
            depTime: this.attr(''),
            arrTime: this.attr(0),
            nextDepTime: this.attr(''),
            distanceToArr: this.attr(''),
            isCurrent: this.attr(false),
            trafficShip: this.attr({}),
            statusHistories: this.attr([]),
            departurePort: this.attr({}),
            destinationPort: this.attr({}),
        }
    }

    static apiConfig = {
        actions: {
            findCurrent(params) {
                return this.get(`traffic/ship/records/current`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            fetchPast(params) {
                return this.get(`traffic/ship/records/past`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
